import { useEffect, useState } from "react";
import { BarChart3 } from "lucide-react";
import api from "@/lib/api";
import PollCard from "@/components/PollCard";

export default function Polls() {
  const [polls, setPolls] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/polls").then((r) => setPolls(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <main className="pt-28 pb-24 bg-white min-h-screen" data-testid="polls-page">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <span className="text-[11px] font-bold uppercase tracking-[0.3em] text-league-blue flex items-center gap-2">
          <BarChart3 size={14} /> Your Voice Counts
        </span>
        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl text-league-ink tracking-tighter mt-3 mb-4">
          FAN <span className="text-outline">POLLS</span>
        </h1>
        <p className="text-muted-foreground max-w-xl mb-14 leading-relaxed">
          One vote per poll. Results update live as Surat has its say on Season 6.
        </p>

        {loading && <p className="text-muted-foreground" data-testid="polls-loading">Loading polls…</p>}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {polls.map((p, i) => (
            <PollCard key={p.id} poll={p} index={i} />
          ))}
        </div>
      </div>
    </main>
  );
}
